import React, { Component, Fragment, useState, useRef, useEffect } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { Query, Mutation } from 'react-apollo';
import { useQuery, useMutation } from 'react-apollo-hooks';
import gql from 'graphql-tag';
import classNames from 'classnames';
import CreatableSelect from 'react-select/lib/Creatable';
import Textarea from 'react-autosize-textarea';

import useBodyScrollLock from '../../hooks/useBodyScrollLock';

const TAGS_QUERY = gql`
  query {
    tags {
      id
      name
      qaCount
      __typename
    }
  }
`;

const ADD_TAG_MUTATION = gql`
  mutation addTag($name: String!) {
    addTag(name: $name) {
      id
      name
    }
  }
`;

const AddTagModal = ({ initialValues = {}, closeModal }) => {
  const scrollable = useRef();
  useBodyScrollLock(scrollable);

  // Available tags
  const { loading, error, data, refetch } = useQuery(TAGS_QUERY);

  const [addTag, { error: addTagError, loading: addTagLoading }] = useMutation(
    ADD_TAG_MUTATION
  );

  if (loading) {
    return 'Loading...';
  }

  if (error || addTagError) {
    return `Error! ${error.message || addTagError.message}`;
  }

  return (
    <Fragment>
      <div className="modal-header">
        <div className="modal-header-title">Lisää Tagi</div>
        <div className="modal-header-close" onClick={closeModal}>
          Sulje
        </div>
      </div>
      <Formik
        initialValues={{
          name: ''
        }}
        onSubmit={async (payload, { setSubmitting }) => {
          const { name } = payload;

          setSubmitting(true);

          await addTag({
            variables: {
              name
            },
            refetchQueries: () => ({ query: TAGS_QUERY }),
            awaitRefetchQueries: true
          });

          closeModal();
        }}
        render={({
          values,
          handleSubmit,
          setFieldTouched,
          setFieldValue,
          isSubmitting
        }) => (
          <Fragment>
            <div className="modal-content" ref={scrollable}>
              <div className="modal-content-form">
                <div className="add-qa-tags">
                  <Form>
                    <Field
                      name="name"
                      render={({ field, form: { isSubmitting } }) => (
                        <input type="text" {...field} disabled={isSubmitting} />
                      )}
                    />
                  </Form>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {isSubmitting && 'Tallennetaan...'}
              {!isSubmitting && (
                <button
                  className="modal-footer-submit-button"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              )}
            </div>
          </Fragment>
        )}
      />
    </Fragment>
  );
};

export default AddTagModal;
